export default {
  // Local Dev
  //API_URL: 'http://localhost',
  //API_PORT: '3000',
  // TST Test
  //API_URL: 'https://api.iam-dev.piemontez.com',
  //API_PORT: '80',
  // Automatico
  API_URL: '',
  API_PORT: '',
  I18N_LOG: false,
};
